function checkDateGreaterThanYear(dateString,min_corp_reg_year) {
  const inputDate = new Date(dateString);
  const currentDate = new Date();
  
  // Вычисляем разницу в миллисекундах между датами
  const timeDiff = currentDate - inputDate;
  
  // Конвертируем разницу в дни
  const daysDiff = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  
  if (daysDiff > min_corp_reg_year*365) {
    return true;
  } else {
    return false;
  }
}


export function dateValid(date) {
	return checkDateGreaterThanYear(date)
}
